import React, { useState, useEffect } from 'react';
import './style.css';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import SquareIcon from '@mui/icons-material/Square';
import http from '../../services/http-service';
// import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { confirm } from 'react-confirm-box';
import { userStatusCommunicationService } from '../../services/communication-service';


function AccountDetails(props) {
    console.log('old props...', props.userId);
    // const history = useHistory();
    const [open, setOpen] = useState(false);
    const [employeeData, setEmployeeData] = useState(props.employeeData ?? {});
    console.log('employeeData', employeeData);
    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };

    const fetchUserDetails = () => {
        console.log('props...', props.userId);
        // return
        handleToggle()
        http('admin/employee/?user__id=' + props.userId, 'GET', '')
            .then(res => {
                if (res.status) {
                    console.log('emsdasasasas......', employeeData)
                    setEmployeeData(res.data.results[0]);
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }

                handleClose()
            },
                err => {
                    console.log('err....', err)
                    handleClose()
                });
    }

    // const getAvailableBalance = () => {
    //     handleToggle()
    //     http('employee/user_avaible_balance_on_dashboard/', 'GET', '', { user_id: props.match.params.id })
    //         .then(res => res.data)
    //         .then(res => {
    //             if (res.status) {
    //                 setPayload(res.payload);
    //                 if (res.payload)
    //                     setAvailableBalace(res.data);
    //                 else
    //                     setPayloadMsg(res.message)
    //                 fetchUserDetails();
    //             }
    //             else {
    //                 toast.error(res.message, {
    //                     toastId: "toastId2"
    //                 })
    //                 handleClose()
    //             }
    //         },
    //             err => {
    //                 console.log('err....', err)
    //                 handleClose()
    //             });
    // }

    useEffect(() => {
        console.log('props.....', props)
        // getAvailableBalance();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openConfirmDialog = async (type) => {
        const text = employeeData.is_active ? 'Disable' : 'Enable'
        const message = type === 'account' ?  'Are you sure, you want to ' + text + ' this account?' : 'Are you sure, you want to perform this action';
        const options = {
            title: "Confirm",
            labels: {
                confirmable: "Confirm",
                cancellable: "Cancel"
            },
            closeOnOverlayClick: false
        }
        const result = await confirm(message, options);
        if (result) {
            if(type == 'account')
            updateAccountStatus(employeeData.is_active)
            else
            updateReportTerminationStatus(employeeData.id)
        }
        console.log("You click No!");
    };

    const updateAccountStatus = (status) => {
        console.log('employee data.......', employeeData)
        let postData = {
            id: employeeData.id,
            is_active: !status
        }

        handleToggle()
        http('admin/update_subadmin_status/', 'PUT', postData)
            .then(res => {
                if (res.data.status) {
                    toast.success(res.data.message, {
                        toastId: "toastId3"
                    })
                    fetchUserDetails()
                }
                else {
                    toast.error(res.data.message, {
                        toastId: "toastId4"
                    })
                    handleClose()
                }

            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const updateReportTerminationStatus = (id) => {
        console.log('employee data.......', id)
        let postData = {
            
        }
        
        
        let user_id = id

        handleToggle()
        http('employer/report_termination/?user_id=' + user_id, 'POST')
            .then(res => {
                if (res.data.status) {
                    userStatusCommunicationService.setUserStatus('Off-boarded')
                    toast.success(res.data.message, {
                        toastId: "toastId3"
                    })
                    fetchUserDetails()
                }
                else {
                    toast.error(res.data.message, {
                        toastId: "toastId4"
                    })
                    handleClose()
                }

            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    return (

        <Grid container className="userPanelRow">
            <Grid item sm={12} md={5} lg={5} className='Grid5Div'>
                <Typography variant="overline" display="block" gutterBottom className='TypoInfo'>
                    CONTACT INFO
                </Typography>
                <Grid container className='UserDetailInnermail'>
                    <Grid item xs={12} md={6} lg={6} className='Grid5Div'>E-mail:</Grid>
                    <Grid item xs={12} md={6} lg={6} className='Grid5Div'>{employeeData.email}</Grid>
                    <Grid item xs={12} md={6} lg={6} className='phoneNumber12'>Phone Number:</Grid>
                    <Grid item xs={12} md={6} lg={6} className='phoneNumber12'>{employeeData.phone_number}</Grid>
                </Grid>
            </Grid>
            <Grid item sm={0} md={2} lg={2}>

            </Grid>
            <Grid item sm={12} md={5} lg={5} className='Grid5Div'>
                <Typography variant="overline" display="block" gutterBottom className='TypoInfo'>
                    USER ID(S)
                </Typography>
                <Grid container className='UserDetailInnermail'>
                    <Grid item xs={12} md={6} lg={6} className='Grid5Div'>User id</Grid>
                    <Grid item xs={12} md={6} lg={6} className='Grid5Div'>{employeeData.profile.emp_id}</Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} className='wagefitGrid'>
                <Grid item xs={2} className='wagefitGridSize2'>
                    <div></div>
                </Grid>
                <Grid item xs={10} className='wagefitGridSize10'><Typography variant="overline" display="block" gutterBottom className='wagefitGridTypo'>
                    <SquareIcon className='squareBox' />   Wagefit account
                </Typography></Grid>
            </Grid>
            <Grid xs={12} className='CretedGridDiv'>
                <Grid container xs={12} className='dividerColor'>
                    <Grid xs={3} className="accountListName">
                        Created
                    </Grid>
                    <Grid xs={3} className="accountListName">
                        Account
                    </Grid>
                    <Grid xs={3} className="accountListName">
                        Routing
                    </Grid>
                    <Grid xs={3} className="accountListName">
                        Note
                    </Grid>
                </Grid>
                {(employeeData.wagefit_account ? (
                    <Grid container xs={12} className='GridTypoWagefit'>
                        <Grid xs={3}>
                            {employeeData.wagefit_account_created}
                        </Grid>
                        <Grid xs={3} >
                            {employeeData.wagefit_account}
                        </Grid>
                        <Grid xs={3} >
                            N/A
                        </Grid>
                        <Grid xs={3} >
                            N/A
                        </Grid>
                    </Grid>
                )
                    : (
                        <Grid xs={12} className='GridTypoWagefit'>
                            <Typography variant="overline" display="block" gutterBottom className='wagefitMessage'>
                                A Wagefit account will be created when the account is active
                            </Typography>
                        </Grid>
                    ))}


            </Grid>
            <Grid item xs={12} className='wagefitGrid wagefitGridMarginTop'>
                <Typography variant="overline" display="block" gutterBottom className='wagefitGridTypo'>
                    PERSONAL ACCOUNTS
                </Typography>
            </Grid>

            <Grid xs={12} className='CretedGridDiv'>
                <Grid container xs={12} className='dividerColor gridPaddingDiv'>
                    <Grid xs={2} className="accountListName">
                        Type
                    </Grid>
                    <Grid xs={2} className="accountListName">
                        Added
                    </Grid>
                    <Grid xs={2} className="accountListName">
                        Bank
                    </Grid>
                    <Grid xs={2} className="accountListName">
                        Account
                    </Grid>
                    <Grid xs={2} className="accountListName">
                        Routing
                    </Grid>
                    <Grid xs={2} className="accountListName">
                        Note
                    </Grid>
                </Grid>

                <Grid container xs={12} className='GridTypoWagefit'>
                    <Grid xs={2}>
                        Primary
                    </Grid>
                    <Grid xs={2}>
                        {/* {employeeData.profile.status_start_date} */}
                        {employeeData.personal_account_added}
                    </Grid>
                    <Grid xs={2}>
                        {employeeData.profile.bankName ? employeeData.profile.bankName : 'N/A'}
                    </Grid>
                    <Grid xs={2}>
                        {employeeData.profile.bank_account_number}
                    </Grid>
                    <Grid xs={2}>
                        {employeeData.profile.postal_code}
                    </Grid>
                    <Grid xs={2}>

                    </Grid>
                </Grid>

            </Grid>

            { employeeData.profile.status !== 'Off-boarded' ? <Grid  xs={12} className='BottomGridBtn'>
                <Stack direction="row" spacing={2} className='BottomGridBtnStack'>
                    <button  className='BottomGridBtnStackBtn' onClick={()=>openConfirmDialog('account')}>{employeeData.is_active ? 'Disable' : 'Enable'}  Account</button>
                    <button className='BottomGridBtnStackBtn' onClick={()=>openConfirmDialog('report')}>Report Termination</button>
                </Stack>
            </Grid> : <></>}
        </Grid>


    )
}

export default AccountDetails;